import React, { useState, useEffect } from "react";

const PropertyTypeSelector = ({ options = [], onSelectionChange }) => {
    
    const [selected, setSelected] = useState(null);
    
    console.log("optionsoptions",options,selected);
  useEffect(() => {
    if (options.length > 0) {
      // Check if the current selected option exists in the new options
      const currentSelected = options.find(option => option.key === selected?.key);

      if (currentSelected) {
        setSelected(currentSelected);
        onSelectionChange(currentSelected);
      } else {
        // Fallback to the first option if the selected one doesn't exist in the new options
        const defaultSelected = options[0];
        setSelected(defaultSelected);
        onSelectionChange(defaultSelected);
      }
    }
  }, [options, selected, onSelectionChange]);

  const handleSelect = (option) => {
    setSelected(option);
    onSelectionChange(option);
  };

  return (
    <div className="flex flex-wrap gap-4 p-4">
      {options.map((option) => (
        <button
          type="button"
          key={option.key}
          onClick={() => handleSelect(option)}
          className={`px-4 py-2 rounded border transition-all ${
            selected?.key === option.key
              ? "bg-green-500 text-white border-green-500"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
          }`}
        >
          {option.value}
        </button>
      ))}
    </div>
  );
};

export default PropertyTypeSelector;
